import { ChevronDown, ChevronRight } from "lucide-react";
import type { BlockComponentProps } from "../registry";
import { LoroTextInput, bodyMap } from "../textField";
import { useT } from "../../i18n";

/** Group block (spec §7.4.1): title plus collapsible children (collapse state lives in BlockTree). */
export function GroupBlock({ handle, node, readOnly, collapsed, onToggleCollapse, onFocus }: BlockComponentProps) {
  const t = useT();
  const body = bodyMap(node);
  if (!body) return null;
  return (
    <div className="flex items-center gap-1 py-1" data-testid="group-block" onFocus={onFocus}>
      <button className="text-neutral-500" onClick={onToggleCollapse} aria-label={collapsed ? t("group.expand") : t("group.collapse")}>
        {collapsed ? <ChevronRight size={16} /> : <ChevronDown size={16} />}
      </button>
      <LoroTextInput handle={handle} map={body} field="title" placeholder={t("group.title")} readOnly={readOnly} className="w-full bg-transparent text-base font-semibold outline-none" testId="group-title" />
    </div>
  );
}
